import Download from '@mui/icons-material/Download';
import { useLogEvent } from 'api/services/LogEventService';
import { downloadSearchAsset } from 'api/services/SearchService';
import { trackSearchEvent } from 'piwik/piwik';
import { useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { Asset } from 'types/Asset';
import { LogEventType } from 'types/LogEvents';

interface DocumentsDisplayProps {
  documents: Asset[];
  data?: any; // can be a product a company or other in the future,
  searchContext?: boolean;
}
export const DocumentsDisplay = ({
  documents,
  data,
  searchContext
}: DocumentsDisplayProps) => {
  const { event } = useParams();
  const logEvent = useLogEvent();
  const downloadNow = (response: any) => {
    logEvent(
      [
        {
          productId: data[0].old_key,
          segment: data[0].segment,
          supplierId: data[0].company.key
        }
      ],
      LogEventType.PRODUCT_DOWNLOAD,
      event
    );
    const file = new Blob([response.data], { type: response.data.type });
    const fileURL = URL.createObjectURL(file);
    window.open(fileURL);
  };

  const downloadAsset = (asset: Asset) => {
    if (searchContext) {
      trackSearchEvent('attachment-download', data[0].name);
    }
    downloadSearchAsset(
      asset.key,
      response => {
        downloadNow(response);
      },
      (error: any) => toast.error(error)
    );
  };
  return (
    <div className="documents-display documents-display-one-column mt-3">
      {documents.map((document: Asset) => {
        return (
          <div
            key={'index' + document.key}
            className="document-wrapper d-flex gap-3"
            onClick={() => downloadAsset(document)}
          >
            <Download fontSize="large" sx={{ mt: '7px' }} />
            <div>
              <span className="document-type">{document.type}</span>
              <p className="document-name">{document.name}</p>
            </div>
          </div>
        );
      })}
    </div>
  );
};
